const parseDate = ( date ) => {
  if (!date) return null;
  if (date instanceof Date) return date;
  if (typeof date === 'string') {
    let newDate = new Date(date);
    // фикс кривой даты для safari "2019-12-06 00:00:00" -> "2019-12-06T00:00:00"
    if (Number.isNaN(+newDate)) newDate = new Date(date.replace(' ', 'T'));
    if (Number.isNaN(+newDate)) return null;
    return newDate;
  }
  return new Date(date);
};
export default parseDate;
